import { ReactNode } from "react"
import RequiredMark from "./RequiredMark"

/**
 * Labelありフォーム用コンポーネント
 * label: 項目名 text
 * isRequired :必須フラグ boolean
 * width:入力項目を入れる箇所の幅
 * remarks: 備考 ReactNode
 * displayRemarks: Remarksの表示切替
 * labelWidth: Label部分の幅
 * positionClassName: Label部分の位置指定
 * @param props
 * @returns
 */
const LabelFormRow: React.FC<{
  label: string
  isRequired?: boolean
  remarks?: ReactNode
  displayRemarks?: boolean
  labelWidth?: number
  Width?: number
  formWidth?: number
  positionClassName?: "d-flex"
}> = (props) => {
  return (
    <div className="label-form-row">
      <div className={`label-form-item min-w-${props.formWidth ?? 10}rem`}>
        <div
          className={`label-form-label ${props.positionClassName} min-w-${
            props.labelWidth ?? 15
          }rem`}>
          <label htmlFor={props.label}>
            {props.label}
            {props.isRequired && <RequiredMark />}
          </label>
        </div>
        <div className={`label-form-value w-${props.Width ?? 30}rem`}>
          {props.children}
        </div>
      </div>
      {props.displayRemarks && (
        <div className="label-form-remarks">{props.remarks}</div>
      )}
    </div>
  )
}

export default LabelFormRow
